import ReviewSimpleForm from './ReviewSimpleForm'

export default ReviewSimpleForm
